/* eslint-disable @typescript-eslint/camelcase */
import { getHubData } from '@/app/infrastructures/misc/Cookies';
import { QueryParamsEntities4 } from './MainApp';
import { Pagination } from './Pagination';


export class HistoryHangingBookingFilterRequest {
  search = "";
  days: any = "";
  existenceStatus = "";
  startDate = "";
  endDate = "";
  page = 1;
  limit = 10;

  constructor(fields?: Partial<HistoryHangingBookingFilterRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}

export class HistoryHangingBooking {
  manifestNo = "";
  sttNo = "";
  aggregator = false;
  hangingDays = 0;
  existenceStatus = "";
  existenceLocation = "";
  existenceUsername = "";
  existenceFindAt = "";
  status = "";
  username = "";
  createdAt = "";

  constructor(fields?: Partial<HistoryHangingBooking>) {
    Object.assign(this, fields);
  }
}

export class HistoryHangingBookingEntities {
  pagination = new Pagination(1, 10, 0);
  data: HistoryHangingBooking[] = [];

  constructor(fields?: Partial<HistoryHangingBookingEntities>) {
    Object.assign(this, fields);
  }
}

export class FollowUpBooking {
  username = "";
  partnerType = "";
  partnerId = 0;
  partnerName = "";

  constructor(fields?: Partial<FollowUpBooking>) {
    Object.assign(this, fields);
  }
}

export class ActivitiesFollowUpBooking {
  activityId = 0;
  activityType = "";
  statusFollowUp = "";
  followUp: FollowUpBooking = new FollowUpBooking();
  username = "";
  createdAt = "";

  constructor(fields?: Partial<ActivitiesFollowUpBooking>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpBooking {
  date = "";
  activities: ActivitiesFollowUpBooking[] = [];

  constructor(fields?: Partial<HistoryFollowUpBooking>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpBookingEntities {
  pagination = new Pagination(1, 10, 0);
  data: HistoryFollowUpBooking[] = [];

  constructor(fields?: Partial<HistoryFollowUpBookingEntities>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpBookingFilterRequest {
  activityType = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<HistoryFollowUpBookingFilterRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}